import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import client from '../contentful';
import ReactMarkdown from 'react-markdown';

const Post = () => {

  const { slug } = useParams();
  const [post, setPost] = useState(null);

  useEffect(() => {
    client.getEntries({ 
      content_type: 'project',
      'fields.slug': slug
    })
    .then(response => setPost(response.items[1]))
  }, [slug]);

  if (!post) return <div>Loading...</div>;


  return (
    <div className='pt-24'>
      <h1>SINGLE POST</h1>
      <img className="h-48 w-96 object-cover " src="url({post.fields.description})" alt="" />
      <h1>{post.fields.client}</h1>
      <p>{post.fields.industry}</p>
      <p>{post.fields.description}</p>
      <p><ReactMarkdown>{post.fields.projectSummary}</ReactMarkdown></p>
      {/* Render other fields as needed */}
    </div>
  );
};

export default Post;